module.exports = __webpack_public_path__ + "web/img/zs.2ba03974.png";